import { reactive, watch, onScopeDispose, type Ref } from "vue"

export interface MediaLinkContext {
  games: string[]
  gameSeries: string[]
  gameConsoles: string[]
  companies: string[]
  tags: string[]
}

function empty(): MediaLinkContext {
  return { games: [], gameSeries: [], gameConsoles: [], companies: [], tags: [] }
}

const state = reactive<MediaLinkContext>(empty())

export function setMediaLinkContext(ctx: Partial<MediaLinkContext>): void {
  state.games = ctx.games ?? []
  state.gameSeries = ctx.gameSeries ?? []
  state.gameConsoles = ctx.gameConsoles ?? []
  state.companies = ctx.companies ?? []
  state.tags = ctx.tags ?? []
}

export function clearMediaLinkContext(): void {
  setMediaLinkContext(empty())
}

export function getMediaLinkContext(): MediaLinkContext {
  return {
    games: [...state.games],
    gameSeries: [...state.gameSeries],
    gameConsoles: [...state.gameConsoles],
    companies: [...state.companies],
    tags: [...state.tags],
  }
}

export function hasMediaLinkContext(): boolean {
  return (
    state.games.length > 0 ||
    state.gameSeries.length > 0 ||
    state.gameConsoles.length > 0 ||
    state.companies.length > 0 ||
    state.tags.length > 0
  )
}

/**
 * Keep the active media-link context in sync with `source` for the lifetime of the
 * calling component (or effect scope); clears the context on unmount/dispose.
 */
export function useMediaLinkContext(source: Ref<Partial<MediaLinkContext>>): void {
  watch(source, (value) => setMediaLinkContext(value), { immediate: true, deep: true })
  onScopeDispose(() => clearMediaLinkContext())
}
